/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import { createApiAction } from 'api/core';

import { SecureTokenContextModel } from 'api/onboarding/getSecureTokenData.schemas';
import { NetworkListEntry } from 'api/network/queryRelationships/index.schemas';

const selfEnrollInVcc = createApiAction({
  method: 'post',
  url: '/api/landing/selfEnroll/vcc',
  requestBodyMapper: ({
    addressBookId,
    secureToken,
    contactTitle,
    firstName,
    lastName,
    phone,
    email,
    isAssistedPay,
    paymentInstructions
  }) => ({
    addressBookId,
    secureToken,
    contactTitle,
    firstName,
    lastName,
    phone,
    email,
    isAssistedPay,
    paymentInstructions
  }),
  markUpdated: {
    entityTypes: [
      SecureTokenContextModel.meta.name,
      NetworkListEntry.meta.name
    ]
  }
});

export default selfEnrollInVcc;